<template>
  <f7-page name="sicreportdetails">
    <back-navbar navName="巡检详情"></back-navbar>
    <div class="card-page" v-if="data">
      <div class="card">
        <div class="top-box">
           <div class="name">{{ moduleLabel }}</div>
          <div
            :class="['status',data.inspectState?'status-green':'status-red']"
          >{{data.inspectState?' 正 常':'异 常'}}</div>
        </div>
        <div class="text-box">
          <div>车&nbsp;&nbsp;&nbsp;&nbsp;间：{{data.inspectObjectModel.facilityName}}</div>
          <div></div>
        </div>
        <div class="text-box">
          <div>产&nbsp;&nbsp;&nbsp;&nbsp;线：{{data.inspectObjectModel.productLine}}</div>
          <div></div>
        </div>
        <div class="text-box">
          <div>工作台：{{data.inspectObjectModel.workshopName}}</div>
          <div></div>
        </div>
        <div class="text-box">
          <div>巡检员：{{data.inspecter}}</div>
          <div></div>
        </div>
        <div class="text-box">
          <div>巡检单号：{{data.inspectNo}}</div>
          <div></div>
        </div>
        <div class="text-box">
          <div>提交时间：{{data.gmtInspect|dateFormat}}</div>
          <div></div>
        </div>
      </div>
      <div class="card">
        <div class="card-content card-content-padding">
          <div class="list media-list">
            <div class="item-subtitle-box">
              <inspection-card
                v-for="(item,index) in items"
                :key="index+1"
                :index="index+1"
                :name="item.displayName.zh"
                :isWork="item.value===1"
                :memo="item.memo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { f7Page, f7PageContent } from "framework7-vue";
import BackNavbar from "@/components/navbar/BackNavbar";
import InspectionCard from "@/components/card/InspectionCard";
import {
  fetchShopfloorCheck
} from "@/api/computercheck.js";
export default {
  components: {
    BackNavbar,
    [f7Page.name]: f7Page,
    [f7PageContent.name]: f7PageContent,
    InspectionCard
  },
  data() {
    return {
      data: null,
      items: [],
      wordName: {}
    };
  },
  computed: {
    moduleLabel() {
      return this.data && this.data.modulesUuid === "server" ? "Server巡检" : "设备巡检";
    }
  },
  methods: {
    getShopfloorCheck() {
      this.$f7.preloader.show();
      fetchShopfloorCheck(this.id)
        .then(result => {
            this.data = result.data;
            this.wordName = result.data.tbShopfloorFacility;
            this.items = [];
            if (result.data.inspectData) {
              let inspectData = result.data.inspectData;
              for (let key in inspectData) {
                this.items.push({
                  key,
                  ...inspectData[key],
                });
              }
            }
        })
        .finally(() => {
          this.$f7.preloader.hide();
        });
    }
  },
  mounted() {
    document.title = "Shopfloor IT Devices Check";
    this.id = this.$f7route.query.id;
    this.getShopfloorCheck();
  }
};
</script>
<style lang="scss">
.page {
  background-color: #efeff4 !important;
}
.card-page {
  margin-bottom: 54px;
}
.list .item-inner {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.item-subtitle-box {
  padding-left: 10px;
}
.mb {
  margin-bottom: 10px;
}
</style>
